module.exports = __webpack_public_path__ + "static/media/h10_howtohelp_bw.0916c096.webp";